module.exports = __webpack_public_path__ + "img/works_titleist_m_btm_off.2ab5e90b.png";